module.exports = "<template>\n    <div ref=\"element\">\n        <slot></slot>\n    </div>\n</template>\n";